// NPM Imports
import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Tooltip, Button, Label, Input } from "@revvsales/components";
import CreatableSelect from "react-select/lib/Creatable";

const getValue = data => {
  const returnValue = {};
  if (data) {
    returnValue.label = data;
    returnValue.value = data;
  }
  return returnValue;
};

// Comonents Imports
const AddReviewersSection = ({
  ownerUserEmail,
  checkToggleValue,
  reviewersList,
  addUserToTheList,
  handleValue,
  removeReviewer,
  checkFormValidation,
  userOptions,
}) => (
  <div className="recipientlistsection-addreviewerlist">
    {/* ------------ Form Fields Labels Section ------------*/}
    <div className="docsharingpopup-sharingform-row">
      <div className="docsharingpopup-sharingform-col recipient-email">
        <Label>Recipients email</Label>
      </div>
      <div className="docsharingpopup-sharingform-col recipient-first-name">
        <Label>First name</Label>
      </div>
      <div className="docsharingpopup-sharingform-col recipient-last-name">
        <Label>Last name</Label>
      </div>

      <div className="docsharingpopup-sharingform-col recipient-edit-access">
        <Label>Access</Label>
      </div>
      <div className="docsharingpopup-sharingform-col recipient-delete" />
    </div>
    {reviewersList &&
      reviewersList.map((reviewer, index) => (
        <div className="recipientlistsection-formrow">
          <div
            className="docsharingpopup-sharingform-col recipient-email"
            data-test="docsharing-popup-user-email">
            <CreatableSelect
              placeholder="Enter email"
              formatCreateLabel={userInput =>
                `+ Add "${userInput.toLowerCase()}"`
              }
              className={reviewer.notValid ? "not-valid-email-recipients" : ""}
              onChange={eventData =>
                handleValue(eventData, index, "user_email")
              }
              options={userOptions}
              value={
                getValue(reviewer.user_email).label
                  ? getValue(reviewer.user_email)
                  : ""
              }
              isClearable={
                getValue(reviewer.user_email).label !== "Enter email"
              }
              data-test="docsharing-popup-user-email"
              autoFocus
            />
          </div>
          <div className="docsharingpopup-sharingform-col recipient-first-name">
            <Input
              type="text"
              className="doc-recipients-input-box"
              disabled={reviewer.disabled}
              value={reviewer.first_name}
              placeholder="First name"
              data-test="docsharing-user-firstname"
              onChange={e => handleValue(e, index, "first_name")}
            />
          </div>
          <div className="docsharingpopup-sharingform-col recipient-last-name">
            <Input
              type="text"
              className="doc-recipients-input-box"
              disabled={reviewer.disabled}
              value={reviewer.last_name}
              placeholder="Last name"
              data-test="docsharing-user-lastname"
              onChange={e => handleValue(e, index, "last_name")}
            />
          </div>
          {ownerUserEmail === reviewer.user_email ? (
            <div className="docsharingpopup-sharingform-col recipient-edit-access">
              <Input
                className="docsharingpopup-sharingform-col"
                isSwitch
                type="checkbox"
                onChange={e => checkToggleValue(e, index)}
                value=""
                checked={
                  ownerUserEmail === reviewer.user_email
                    ? true
                    : reviewer.is_editable
                }
                data-test="addreviewerssection-useremail-checkbox"
              />

              <div className="docsharingpopup-sharingform-col">
                can edit document
              </div>
            </div>
          ) : (
            <Tooltip
              placement="top"
              align={{
                offset: [0, 4],
              }}
              overlay={`${
                // eslint-disable-next-line no-nested-ternary
                !reviewer.isEdit
                  ? "Cannot give edit access outside of Revv org"
                  : reviewer.is_editable
                  ? "Give view only access to teammate"
                  : "Give edit access to teammate"
              }`}>
              <div className="docsharingpopup-sharingform-col recipient-edit-access">
                <Input
                  className="docsharingpopup-sharingform-col"
                  disabled={!reviewer.isEdit}
                  isSwitch
                  type="checkbox"
                  onChange={e => checkToggleValue(e, index)}
                  value=""
                  checked={
                    ownerUserEmail === reviewer.user_email
                      ? true
                      : reviewer.is_editable
                  }
                  data-test="addreviewerssection-edit-checkbox"
                />

                <div className="docsharingpopup-sharingform-col">
                  can edit document
                </div>
              </div>
            </Tooltip>
          )}
          <div className="docsharingpopup-sharingform-col recipient-delete">
            <Tooltip
              placement="top"
              align={{
                offset: [0, 4],
              }}
              overlay="Delete recipient">
              <span
                className="btn-icon"
                onClick={() => removeReviewer(index)}
                onKeyPress={() => {}}
                role="button"
                data-test="addreviewerssection-delete"
                tabIndex="0">
                <FontAwesomeIcon icon={["far", "trash-alt"]} />
              </span>
            </Tooltip>
          </div>
        </div>
      ))}

    {/* ------------------- Add more users and share section ------------------- */}
    <div className="docsharingpopup-sharingform-footer">
      <div className="docsharingpopup-addmoreuser-btn">
        <Button
          className="revv-btn-secondary"
          data-test="docsharing-popup-add-btn"
          disabled={!checkFormValidation(false)}
          onClick={() => addUserToTheList()}>
          <i className="plusiconadd">
            <FontAwesomeIcon icon={["far", "plus"]} className="" />{" "}
          </i>
          &nbsp; Add recipient
        </Button>
      </div>
    </div>
  </div>
);

export default AddReviewersSection;



// WEBPACK FOOTER //
// ./src/components/DocumentApprovalPopupNew/AddRecipientsPopup/AddReviewersSection/index.js